import { usePostHttp } from "../../../../hooks/http/http.hook";
import type { IProposalSocial } from "./get-proposal-socials.hook";

interface IBody {
  social: string;
}

interface IResponse {
  campaignProposalSocial: IProposalSocial;
}

export function useAddProposalSocialHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/brand/campaigns/proposals/:proposalId/socials",
  });
}
